export default {
  title: 'Testiravintolat',
  description:
    'Jokainen kumppani voi merkitä yhden ravintolan testiravintolakseen. Se toimii kuin mikä tahansa muu ravintola, eikä siitä koskaan laskuteta. Slack-hälytys lähtee, kun sen kuukausimyynti ylittää raja-arvon.',
  empty: 'Yhdelläkään kumppanilla ei ole testiravintolaa.',
  columns: {
    partner: 'Kumppani',
    restaurant: 'Ravintola',
    designated: 'Merkitty testiksi',
    gmv: 'GMV tässä kuussa',
  },
  statuses: {
    live: 'Käytössä',
    paused: 'Offline',
    suspended: 'Keskeytetty',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'Vaihtokurssia ei ole tallennettu',
  },
  actions: {
    remove: 'Poista testimerkintä',
  },
  toasts: {
    load_error: 'Testiravintoloita ei voitu ladata.',
  },
};
